// PostCard.js (דוגמה, שינוי דומה ב-FeaturedPost)
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Clock, Eye } from 'lucide-react';
import { format } from 'date-fns';
import { he, enUS } from 'date-fns/locale'; // ייבוא שני הלוקאלים
import { Badge } from '../ui/badge.jsx';
import { stripHtml } from '../../entities/BlogPost';

const categoryColors = {
    computer_science: 'bg-[#b8c1ec] text-[#232946]',
    judaism_philosophy: 'bg-[#f6ecd6] text-[#232946]',
    art: 'bg-[#eebbc3] text-[#232946]',
    neuroscience: 'bg-[#cfe5e0] text-[#232946]',
    psychology: 'bg-[#ebccf4] text-[#232946]',
    other: 'bg-[#88abb3] text-white'
};

const categoryNames = {
    computer_science: 'מדעי המחשב',
    judaism_philosophy: 'יהדות ופילוסופיה',
    art: 'אמנות',
    neuroscience: 'מדעי המוח',
    psychology: 'פסיכולוגיה ונפש האדם',
    other: 'אחר'
};


export default function PostCard({ post }) {
    const { t, i18n } = useTranslation();

    // בחירת לוקאל התאריך לפי שפת הממשק
    const dateLocale = i18n.language === 'en' ? enUS : he;

    return (
        <motion.article
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="group rounded-2xl overflow-hidden bg-white shadow hover:shadow-lg transition-shadow duration-300"
        >
            <Link to={`/post/${post.id}`} className="block bg-white rounded-2xl overflow-hidden transition-all duration-500 hover:shadow-xl">
                <div className="aspect-[16/9] overflow-hidden">
                    <img
                        src={
                            post.imageUrl?.trim()
                                ? post.imageUrl
                                : 'https://images.unsplash.com/photo-1516414447565-b14be0adf13e?auto=format&fit=crop&q=80'
                        }
                        alt={post.title}
                        className="object-cover w-full h-full transform transition-transform duration-500 group-hover:scale-105"
                    />
                </div>

                <div className="p-6 md:p-8">
                    <div className="flex flex-wrap items-center gap-3 mb-4">
                        <Badge className={`${categoryColors[post.category]} text-sm px-3`}>
                            {t(`categories.${post.category}`)} {/* תרגום שם הקטגוריה */}
                        </Badge>
                        {post.createdAt && (
                            <div className="flex items-center gap-1 text-[#8890b3] text-sm">
                                <Clock className="w-4 h-4" />
                                <time dateTime={post.createdAt}>
                                    {format(new Date(post.createdAt), 'dd MMMM yyyy', { locale: dateLocale })}
                                </time>
                            </div>
                        )}
                        <div className="flex items-center gap-1 text-[#8890b3] text-sm">
                            <Eye className="w-4 h-4" />
                            <span>{post.views} {t('post.views')}</span> {/* תרגום "צפיות" */}
                        </div>
                    </div>

                    <h2 className="text-xl font-bold mb-3 text-[#232946] group-hover:text-[#232946]/80 transition-colors">
                        {post.title}
                    </h2>

                    <p className="text-[#8890b3] line-clamp-3">
                        {stripHtml(post.excerpt || post.content).slice(0, 80) + '...'}
                    </p>
                </div>
            </Link>
        </motion.article>
    );
}